// 캐시 저장소
const cache = new Map();

// 캐시 TTL (기본값: 5분)
const DEFAULT_TTL = 5 * 60 * 1000;

// 전역에서 캐시 무효화 함수 사용 가능하도록 설정
if (typeof window !== 'undefined') {
  window.invalidateCache = (key) => {
    if (key) {
      cache.delete(key);
      console.log(`전역 캐시 무효화: ${key}`);
    } else {
      cache.clear();
      console.log('전역 전체 캐시 무효화');
    }
  };
}

/**
 * 캐시된 데이터를 가져오거나 새로운 데이터를 가져와 캐시에 저장
 * @param {string} key - 캐시 키
 * @param {Function} fetchFn - 데이터를 가져오는 함수
 * @param {number} ttl - 캐시 유효 시간 (밀리초)
 * @returns {Promise<any>} - 캐시된 데이터 또는 새로 가져온 데이터
 */
export const getCachedData = async (key, fetchFn, ttl = DEFAULT_TTL) => {
  const cached = cache.get(key);
  
  // 캐시가 있고 유효한 경우
  if (cached && Date.now() - cached.timestamp < ttl) {
    console.log(`캐시 히트: ${key}`);
    return cached.data;
  }
  
  // 캐시가 없거나 만료된 경우
  console.log(`캐시 미스: ${key}`);
  const data = await fetchFn();
  
  // 새로운 데이터를 캐시에 저장
  cache.set(key, {
    data,
    timestamp: Date.now()
  });
  
  return data;
};

/**
 * 캐시를 무효화
 * @param {string} key - 캐시 키
 */
export const invalidateCache = (key) => {
  if (key) {
    cache.delete(key);
    console.log(`캐시 무효화: ${key}`);
  } else {
    cache.clear();
    console.log('전체 캐시 무효화');
  }
};

/**
 * 캐시 상태 확인
 * @returns {Object} - 캐시 상태 정보
 */
export const getCacheStats = () => {
  return {
    size: cache.size,
    keys: Array.from(cache.keys()),
    entries: Array.from(cache.entries()).map(([key, value]) => ({
      key,
      age: Date.now() - value.timestamp
    }))
  };
}; 